<fleet-dialog-layout title="Login to exit kiosk mode">
  <div slot="main">
    @if (loginForm) {
      <form
        class="mt-8"
        [formGroup]="loginForm"
        #signInNgForm="ngForm"
        >
        <mat-form-field class="w-full">
          <mat-label>Email address</mat-label>
          <input
            autocomplete="off"
            data-lpignore="true"
            data-form-type="other"
            id="email"
            matInput
            [formControlName]="'username'"
            />
          @if (loginForm.get('username').hasError('required')) {
            <mat-error>
              Email address is required
            </mat-error>
          }
          @if (loginForm.get('username').hasError('email')) {
            <mat-error>
              Please enter a valid email address
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full">
          <mat-label>Password</mat-label>
          <input
            autocomplete="off"
            data-lpignore="true"
            data-form-type="other"
            id="password"
            matInput
            type="password"
            [formControlName]="'password'"
            #passwordField
            />
          <button
            mat-icon-button
            type="button"
          (click)="
            passwordField.type === 'password'
              ? (passwordField.type = 'text')
              : (passwordField.type = 'password')
          "
            matSuffix
          ></button>
          <mat-error> Password is required </mat-error>
        </mat-form-field>
        @for (alert of error | alertsFromIssues; track alert) {
          <fuse-alert
            class="py-3"
            [appearance]="'outline'"
            [showIcon]="true"
            [type]="alert.type"
            [@shake]="alert.type === 'error'"
            >
            {{ alert.message }}
          </fuse-alert>
        }
        <button
          mat-flat-button
          class="bg-primary-600 text-white disabled:bg-gray-200 fuse-mat-button-large w-full mt-6"
          [disabled]="loginForm.disabled || loginForm.invalid || loading"
          (click)="submit()"
          >
          @if (!loginForm.disabled) {
            <span> Submit </span>
          }
          @if (loading) {
            <mat-progress-spinner
              [diameter]="24"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
          }
        </button>
      </form>
    }
  </div>
</fleet-dialog-layout>
